const $ = jQuery;
const selectors = {
	visibleSearchForm: 'form[role=search]:visible',
	searchForm: 'form[role=search]',
	divi: {
		searchForm: 'form[role=search].et_pb_searchform,form[role=search].et_pb_menu__search-form',
		searchFormContainer: {
			displayCSSBased: '.fl-search',
			etPbClass: '.et_pb_menu__search-container',
		},
		searchFormIcon: [
			'.fl-search .et-pb-icon, .fl-search .fa-search',
			'.fl-search-links',
			'.et_pb_menu__search-button',
			'#et_search_icon,.fl-search,.fl-search-button,.fl-search-btn',
		],
		cleanupNodes: '.fl-search-close',
	},
};
const allSearchForms = () => $(selectors.searchForm);
const getVisibleSearchForm = () => $(selectors.visibleSearchForm);
const getVisibleSearchInput = () => getVisibleSearchForm()
	.find('input[name=s]');
const getSearchIcon = () => {
	for (let i = 0; i < selectors.divi.searchFormIcon.length; i++) {
		if ($(selectors.divi.searchFormIcon[i]).length) {
			const result = $($(selectors.divi.searchFormIcon[i]));
			if (!result.find('form[role=search]').length) {
				return result;
			}
		}
	}
	return $([]);
};
const getEtPbMenuWrap = form => $(form)
	.closest('.et_pb_module')
	.find('.et_pb_menu__wrap')
	.first();
const hideDiviSearchFormContainer = () => {
	const s = selectors.divi.searchFormContainer;
	allSearchForms()
		.each(function () {
			if ($(this)
				.parents(s.displayCSSBased).length) {
				$(this)
					.parents(s.displayCSSBased)
					.hide();
			} else if ($(this)
				.parents(s.etPbClass).length) {
				$(this)
					.parents(s.etPbClass)
					.removeClass('et_pb_menu__search-container--visible')
					.addClass('et_pb_menu__search-container--hidden')
					.addClass('et_pb_menu__search-container--disabled');
				getEtPbMenuWrap(this)
					.removeClass('et_pb_menu__wrap--hidden')
					.addClass('et_pb_menu__wrap--visible');
			} else {
				$(this)
					.parent()
					.hide();
			}
		});
};
const showDiviSearchFormContainer = () => {
	const s = selectors.divi.searchFormContainer;
	allSearchForms()
		.each(function () {
			if ($(this)
				.parents(s.displayCSSBased).length) {
				$(this)
					.parents(s.displayCSSBased)
					.show();
			} else if ($(this)
				.parents(s.etPbClass).length) {
				$(this)
					.parents(s.etPbClass)
					.removeClass('et_pb_menu__search-container--hidden')
					.removeClass('et_pb_menu__search-container--disabled')
					.addClass('et_pb_menu__search-container--visible');
				getEtPbMenuWrap(this)
					.addClass('et_pb_menu__wrap--hidden')
					.removeClass('et_pb_menu__wrap--visible');
			} else {
				$(this)
					.parent()
					.show();
			}
		});
};
const injectStyle = (content) => {
	const stylesheet = document.createElement('style');
	stylesheet.innerHTML = content;
	document.body.appendChild(stylesheet);
};

const fixButtonAndInputOffsets = function (form) {
	const searchInput = $(form)
		.find('input[name=s]');
	const searchCloseButton = $(form)
		.find('button[type=reset]');
	const searchButton = $(form)
		.find('input[type=submit]:visible');
	let pixelShift = 0;
	let paddingRight = 0;
	let right = ($(form)
		.offset().left + $(form)
			.outerWidth());
	right -= (searchInput.offset().left + searchInput.outerWidth());
	if (searchButton.length) {
		if (searchInput.offset().left < searchButton.offset().left) {
			pixelShift = (searchInput.offset().left + searchInput.outerWidth()) - (searchButton.offset().left);
			pixelShift = Math.max(pixelShift, 0);
			paddingRight += pixelShift;
			right += pixelShift;
		}
	}

	const isLegacySearchInput = searchInput.hasClass('search-field');
	if (searchCloseButton.is(':visible') || isLegacySearchInput) {
		paddingRight += searchCloseButton.outerWidth();
	}
	if ($(form)
		.parents('.et_pb_menu__search-container').length === 0) {
		searchCloseButton.get(0)
			.style
			.setProperty('right', `${right}px`, 'important');
	}
	searchInput.get(0)
		.style
		.setProperty('padding-right', `${paddingRight}px`, 'important');
};

const forceLoadHandler = (handler) => {
	handler();
	// Custom JS starts after timeout
	window.setTimeout(() => {
		handler();
	}, 1000);
	// Divi re-adds handlers on page resize
	$(window)
		.on('resize', () => {
			handler();
		});
};
const cleanupExtraNodes = () => {
	$(selectors.divi.cleanupNodes)
		.remove();
};
const init = function () {
	const IS_SEARCH_FORM_VISIBLE_BY_DEFAULT = getVisibleSearchForm().length > 0;
	const IS_DIVI_WIDGET_SEARCH_FORM = $(selectors.divi.searchForm).length > 0;

	if ($('.menu-item-has-children > a').length) {
		$('.menu-item-has-children > a')
			.addClass('da11y-submenu');
		$('.menu-item-has-children > a')
			.attr('aria-expanded', 'false');
	}

	$('.da11y-submenu')
		.on('focus', function () {
			$(this)
				.not('.sub-menu a')
				.attr('aria-expanded', 'true');
			$(this)
				.siblings('.sub-menu')
				.addClass('da11y-submenu-show');
			$(this)
				.trigger('mouseenter');
		});

	// This block of code helps to understand if the last event was caused by keyboard
	const KEYCODE_TAB = 9;
	const KEYCODE_ESC = 27;
	let lastKeyCode = null;
	let isShiftUsed = null;
	$(document)
		.on('click', '*', () => {
			lastKeyCode = null;
			isShiftUsed = null;
		});
	$(document)
		.on('keydown', '*', (e) => {
			lastKeyCode = e.keyCode;
			isShiftUsed = e.shiftKey;
		});
	$(document)
		.on('keyup', '*', (e) => {
			lastKeyCode = e.keyCode;
			isShiftUsed = e.shiftKey;
		});

	$('.menu-item-has-children a')
		.on('focusout', function () {
			if ($(this)
				.parent()
				.not('.menu-item-has-children')
				.is(':last-child') &&
			!(isShiftUsed && lastKeyCode === KEYCODE_TAB)
			) {
				const nextMenuItem = $(this).parents('.menu-item-has-children').first().next('li.menu-item');
				$(this).parents('.menu-item-has-children')
					.children('.da11y-submenu')
					.attr('aria-expanded', 'false')
					.trigger('mouseleave')
					.siblings('.sub-menu')
					.removeClass('da11y-submenu-show');

				// Focus on the next menu item if it exists and the last pressed key was not ESC
				if (nextMenuItem && lastKeyCode !== KEYCODE_ESC) {
					nextMenuItem.trigger('mouseenter');
				}
			}
		});

	$('.menu-item-has-children a')
		.keyup(function (event) {
			if (event.keyCode === 27) {
				const menuParent = $(this)
					.parents('.menu-item-has-children')
					.last();
				if (menuParent.length) {
					menuParent.children('a')
						.focus();
					menuParent.find('.da11y-submenu')
						.attr('aria-expanded', 'false')
						.trigger('mouseleave')
						.siblings('.sub-menu')
						.removeClass('da11y-submenu-show');
				}
			}
		});

	function setSearchTabIndex(value) {
		$(selectors.searchForm)
			.find('input.et-search-field,input[name=s],button,input[type=submit]')
			.filter(function() {
				return $(this).parents('.widget_search form[role=search], .page-blog #main-content form.et_pb_searchform').length === 0;
			})
			.attr('tabindex', value);

		if (value >= 0) {
			setTimeout(() => {
				getVisibleSearchInput()
					.focus();
			}, 100);
		}
	}

	/**
	 * @Todo re-write using observers
	 */
	function toggleSearchTabIndex() {
		setTimeout(() => {
			setSearchTabIndex(getVisibleSearchForm().length >= 1 ? 0 : -1);
		}, 100);
	}

	function setInitialTabIndex() {
		if (IS_DIVI_WIDGET_SEARCH_FORM) {
			if (!IS_SEARCH_FORM_VISIBLE_BY_DEFAULT) {
				setSearchTabIndex(-1);
			}
			return;
		}
		setSearchTabIndex(-1);
	}

	/**
	 * Hide the search.
	 *
	 * @since Divi v3.0.23
	 */
	function hideSearch() {
		if (IS_DIVI_WIDGET_SEARCH_FORM) {
			if (!IS_SEARCH_FORM_VISIBLE_BY_DEFAULT) {
				hideDiviSearchFormContainer();
				setSearchTabIndex(-1);
			}
			return;
		}
		if ($('.et_search_form_container')
			.hasClass('et_pb_is_animating')) {
			return;
		}
		$('.et_menu_container')
			.removeClass('et_pb_menu_hidden et_pb_no_animation')
			.addClass('et_pb_menu_visible');
		$('.et_search_form_container')
			.removeClass('et_pb_search_visible et_pb_no_animation')
			.addClass('et_pb_search_form_hidden et_pb_is_animating');
		setTimeout(() => {
			$('.et_menu_container')
				.addClass('et_pb_no_animation');
			$('.et_search_form_container')
				.addClass('et_pb_no_animation')
				.removeClass('et_pb_is_animating');
		}, 1000);
		setSearchTabIndex(-1);
	}

	setInitialTabIndex();
	const refreshStateOfCloseSearchButton = (formNode) => {
		const searchCloseButton = $(formNode)
			.find('button[type=reset]');
		if ($(formNode)
			.find('input[name=s]')
			.val()) {
			searchCloseButton.show(0, () => fixButtonAndInputOffsets(formNode));
		} else {
			searchCloseButton.hide(0, () => fixButtonAndInputOffsets(formNode));
		}
	};

	/**
	 * Add unique ID to search module input with matching label.
	 *
	 * @divi-module  Search
	 */
	$('.et-search-field')
		.each(function (e) {
			$(this)
				.attr('id', `et_pb_search_module_input_${e}`);
			$(`#et_pb_search_module_input_${e}`)
				.before(`<label class="da11y-screen-reader-text" for="et_pb_search_module_input_${e}">Search for...</label>`);
			$(`#et_pb_search_module_input_${e}`)
				.after('<button type="submit" class="" aria-label="Submit Search"></button>');
		});
	if (!IS_DIVI_WIDGET_SEARCH_FORM) {
		// Moving the close search button before the submit
		// Refresing the state of close search button
		$('.et_close_search_field')
			.each(function () {
				$(this)
					.attr('type', 'reset');
				$(this)
					.parent()
					.find('form')
					.find('button[type=submit]')
					.before(this);
			});
	}

	/**
	 * Add unique ID to contact module input with matching label.
	 *
	 * @divi-module  Contact
	 */
	$('.et_pb_contact_form')
		.each(() => {
			$(this)
				.find('.et_pb_contact_captcha_question')
				.parent()
				.wrap('<label></label>');
		});

	// Make the non-standard search buttons keyboard accessible
	if (IS_DIVI_WIDGET_SEARCH_FORM) {
		getSearchIcon()
			.each(function () {
				if (!$(this)
					.attr('aria-label')) {
					$(this)
						.attr('aria-label', 'Open Search');
				}
				if ($(this)
					.closest('a').length) {
					$(this)
						.parents('a')
						.on('keydown', (e) => {
							if ((e.key === 'Enter') || (e.key === 'Space')) {
								e.preventDefault();
								$(this)
									.click();
							}
						});
					return;
				}
				$(this)
					.attr('tabindex', '0');
				$(this)
					.on('keydown', (e) => {
						if (e.key === 'Enter') {
							$(this)
								.click();
						}
					});
			});

		const searchButton = $('form[role=search] input[type=submit]');
		const searchInput = $('form[role=search] input[name=s]');
		searchButton.each(function () {
			if (!$(this)
				.attr('aria-label')) {
				$(this)
					.attr('aria-label', 'Submit Search');
			}
		});
		searchInput.each(function () {
			if ($(this)
				.attr('type') === 'search') {
				$(this)
					.attr('type', 'text');
			}
			if (!$(this)
				.attr('placeholder')) {
				$(this)
					.attr('placeholder', 'Search');
			}
			$(this)
				.after('<button type="reset" role="button" class="et_close_search_field" aria-label="Clear Search" style="display:none;"></button>');
		});
		const searchCloseButton = $('.et_close_search_field');
		searchCloseButton.css('color', searchInput.css('color'));
		if ((searchButton.css('display') === 'none') && (searchButton.closest('.et_pb_hide_search_button').length === 0)) {
			searchButton.val('\uf002')
				.addClass('fas fa')
				.css('color', 'inherit !important');
			searchButton.css('display', 'block');
		}
		// Setting position for the close button
		// There are three possible cases:
		// - Case 1, Case when search button implemented as a pseudo element of the search form, in this case we should also fix
		//   the search button
		// - Case 2, Case when search button positioned as an absolute element and the input search field has wrong right padding
		// - Case 3, Default case, search input and search button positioned correctly and they are separate elements
		const form = $('form[role=search]')
			.get(0);
		const isCase1 = getComputedStyle(form, 'after') && getComputedStyle(form, 'after').position === 'absolute';
		if (isCase1) {
			// case 1
			// transforming the state to case 1
			searchButton.val('\uf002')
				.addClass('fas fa')
				.css('color', 'inherit !important');
			injectStyle('.fl-search:after {content: none !important}');
		}
		if (!IS_SEARCH_FORM_VISIBLE_BY_DEFAULT) {
			showDiviSearchFormContainer();
		}

		allSearchForms()
			.each(function () {
				$(this)
					.find('input[name=s]')
					.on('focus', function () {
						fixButtonAndInputOffsets($(this)
							.parents('form')
							.get(0));
					});
				const legacySearchInput = $(this).find('input.search-field').get(0);
				if (legacySearchInput) {
					fixButtonAndInputOffsets(this);
				}
			});

		if (!IS_SEARCH_FORM_VISIBLE_BY_DEFAULT) {
			hideDiviSearchFormContainer();
		}
	}

	forceLoadHandler(() => {
		// Re-write the behaviour of search close button
		// now it is a search clear button
		$('.et_close_search_field')
			.off('click')
			.click((e) => {
				e.preventDefault();
				getVisibleSearchInput()
					.val('')
					.focus()
					.trigger('keyup');
			});
		cleanupExtraNodes();
		$('.et_pb_menu__close-search-button')
			.attr('aria-label', 'Close Search');
	});
	allSearchForms()
		.each(function () {
			const self = this;
			$(this)
				.find('input[name=s]')
				.on('keyup', () => {
					refreshStateOfCloseSearchButton(self);
				});
		});
	$(document)
		.off('blur', '.et_pb_menu__search-input');
	// Close the search form if any of its elements lost the focus
	$(selectors.searchForm)
		.parent()
		.on('focusout', function (e) {
			if (!$.contains(this, e.relatedTarget)) {
				hideSearch();
			}
		});
	getSearchIcon()
		.click(() => {
			toggleSearchTabIndex();
		});
};

export default function () {
	$(init);
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/search/search-form.js